// HTTP Status Codes
export const HTTP_STATUS = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  INSUFFICIENT_STORAGE: 507,
};

// API Response Status
export const API_STATUS = {
  SUCCESS: 1,
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK: {
    NO_RESPONSE:
      'Không thể kết nối đến máy chủ. Vui lòng kiểm tra kết nối mạng và thử lại.',
    GENERAL: 'Đã xảy ra lỗi. Vui lòng thử lại sau.',
    NO_SERVER_RESPONSE: 'Không nhận được phản hồi từ máy chủ.',
  },
  HTTP: {
    [HTTP_STATUS.BAD_REQUEST]:
      'Yêu cầu không hợp lệ. Vui lòng kiểm tra lại thông tin.',
    [HTTP_STATUS.UNAUTHORIZED]:
      'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',
    [HTTP_STATUS.FORBIDDEN]: 'Bạn không có quyền thực hiện thao tác này.',
    [HTTP_STATUS.NOT_FOUND]: 'Không tìm thấy tài nguyên được yêu cầu.',
    [HTTP_STATUS.UNPROCESSABLE_ENTITY]:
      'Dữ liệu không hợp lệ. Vui lòng kiểm tra lại.',
    [HTTP_STATUS.TOO_MANY_REQUESTS]: 'Quá nhiều yêu cầu. Vui lòng thử lại sau.',
    [HTTP_STATUS.INTERNAL_SERVER_ERROR]: 'Lỗi máy chủ. Vui lòng thử lại sau.',
    [HTTP_STATUS.SERVICE_UNAVAILABLE]:
      'Dịch vụ tạm thời không khả dụng. Vui lòng thử lại sau.',
    [HTTP_STATUS.INSUFFICIENT_STORAGE]:
      'Không đủ dung lượng lưu trữ. Vui lòng thử lại sau.',
  },
  API: {
    SUCCESS: 'Thao tác thành công.',
    FAILURE: 'Thao tác thất bại.',
  },
  FILE: {
    UPLOAD_FAILED:
      'Không thể tải lên file. Vui lòng kiểm tra kết nối và thử lại.',
    TOO_LARGE: 'File quá lớn. Vui lòng chọn file nhỏ hơn.',
    UNSUPPORTED_FORMAT: 'Định dạng file không được hỗ trợ.',
  },
  AUTH: {
    CONNECTION_FAILED:
      'Không thể xác thực. Vui lòng kiểm tra kết nối và thử lại.',
    SESSION_EXPIRED: 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',
    UNAUTHORIZED: 'Bạn không có quyền truy cập.',
  },
};
